window.ARAMORE = window.ARAMORE || {};
window.ARAMORE.shippingThreshold = 50;

let abTestInitialized = false;
const targetShippingBarSelector = '.abconvert-banner-text';
const targetNode = document.getElementById("shopify-section-header");
const announcementBar = document.querySelector('.discount_top_note');

const observer = new MutationObserver((mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      let abTestShippingBar = document.querySelector(targetShippingBarSelector);
      if (abTestShippingBar) {
        initABTest();
      } else {
        abTestInitialized = false;
      }
    }
  }
});

const getShippingThreshold = (shippingMessage) => {
  const shippingThresholdRegex = /\d+/;
  const matches = shippingMessage.match(shippingThresholdRegex);

  if (matches && matches.length) {
    return matches[0];
  }
}

const updateCartTotals = () => {
  const cartFooter = document.querySelector('.cart__footer');
  const shippingValue = document.querySelector('.totals__shipping-value');
  const shippingThreshold = window.ARAMORE.shippingThreshold;
  if (cartFooter && typeof thisCart !== 'undefined' && window?.ARAMORE?.shippingThreshold) {
    const cartTotalNumber = thisCart.total_price / 100;
    shippingValue.textContent = shippingThreshold > cartTotalNumber ? 'TBD' : 'FREE';
  }
}

// Init A/B Test Elements
const initABTest = () => {
  let abTestShippingBar = document.querySelector(targetShippingBarSelector);
  const shippingBarCloseBtn = document.querySelector('.abconvert-close-button');
  const shippingBarOuterElement = document.querySelector('.abconvert-free-shipping-bar');
  
  if (abTestShippingBar && !abTestInitialized) {
    let shippingMessage = abTestShippingBar.textContent;
    abTestShippingBar.classList.add('uppercase');
    abTestShippingBar.textContent = shippingMessage.replace('.00', '');
    
    if (announcementBar) {
      announcementBar.classList.add('hidden');
    }

    if (shippingBarCloseBtn) {
      shippingBarCloseBtn.classList.add('hidden');
    }

    shippingBarOuterElement.style.display = 'block';
    abTestInitialized = true;

    window.ARAMORE.shippingThreshold = getShippingThreshold(abTestShippingBar.textContent);

    updateCartTotals();
  } else {
    observer.observe(targetNode, { attributes: true, childList: true, subtree: true });
  }
}

initABTest();

window.addEventListener('load', () => {
  if (announcementBar && announcementBar.classList.contains('hidden')) {
    announcementBar.style.display = 'block';
  }
});